<app-report [actionsConfig]="['path_explorer_filter']"
            [paramsConfig]="['attributed_metric', 'new_period_without_comparison']"
            [disableComparison]="true"
            [enableDialogs]="true">
  <div actions></div>
  <div class="full-height relative">
    <app-loader [enable]="loading$ | async">
      <div class="display-flex flex-column full-height">
        <app-jumbotron class="flex-grow">
          <app-path-explorer-report-table [rows]="data$ | async"
                                          [requestParams]="requestParams$ | async"
                                          [totals]="totals$ | async"></app-path-explorer-report-table>
        </app-jumbotron>
        <app-conversion-path-legend class="mt-5" [data]="data$ | async"></app-conversion-path-legend>
      </div>
    </app-loader>
  </div>
</app-report>
